import { render, staticRenderFns } from "./QuestionResponses.vue?vue&type=template&id=7afcf635&scoped=true&"
import script from "./QuestionResponses.vue?vue&type=script&lang=js&"
export * from "./QuestionResponses.vue?vue&type=script&lang=js&"
import style0 from "./QuestionResponses.vue?vue&type=style&index=0&id=7afcf635&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7afcf635",
  null
  
)

export default component.exports